<template>
  <v-app style="background-color: white;">
    <v-main>
      <nav-bar></nav-bar>
      <v-container fluid>
        <!--        <v-divider class="error"></v-divider>-->
        <router-view></router-view>
      </v-container>
    </v-main>
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="3000"
      bottom
    >
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar.show = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import NavBar from "@/components/shared/NavBar";
export default {
  components: {
    NavBar
  },
  name: "App",
  computed: {
    cartExpires: () => this.$store.state.cartExpires
  },
  data() {
    return {
      snackbar: {
        show: false,
        message: "",
        color: ""
      }
    };
  },
  mounted() {
    this.$root.$on("showSnackbar", payload => {
      this.snackbar.show = true;
      this.snackbar.message = payload.message;
      this.snackbar.color = payload.color;
    });
    this.clearCartInterval = setInterval(() => {
      if (this?.$store?.state?.cartExpires) {
        const cartExpires = this?.$store?.state?.cartExpires;
        if (cartExpires && cartExpires < Date.now() / 1000) {
          this.$store.dispatch("CLEAR_CART");
        }
      }
    }, 5000);
  },
  destroyed: () => {
    clearInterval(this.clearCartInterval);
  }
};
</script>
<style>
.v-sheet.v-card {
  border-radius: 8px;
}

/* Default background for desktop/tablet */
.v-application {
  background-color: white !important;
}

@media (min-width: 1904px) {
  /* Skip this max-width change. doesn't look good. */
  .container {
    max-width: 1185px;
  }
}

/* Mobile background */
@media (max-width: 600px) {
}
</style>
